// Copyright (c) 2018 Deere & Company

import t from 'tcomb';

const ExcelLayoutSortBy = t.struct({
    column: t.String,
    direction: t.String
}, {
    name: 'ExcelLayoutSortBy',
    strict: true
});

export const getDefaultState = () => new ExcelLayoutSortBy({
    column: '',
    direction: 'A'
});

export default ExcelLayoutSortBy;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/excel-layout-sort-by.js